import { Link } from "react-router-dom";
import { Check, ArrowRight } from "lucide-react";
import { useLang } from "../contexts/LangContext";
import { IMAGES } from "../lib/images";
import useSEO from "../lib/useSEO";

export default function Weddings() {
  const { t } = useLang();
  useSEO({
    title: "Hochzeitscatering Lausitz & Hoyerswerda — Pizza Catering Hochzeit | Tæste",
    description:
      "Hochzeitscatering aus Lohsa für Paare in der Lausitz und Hoyerswerda. Handgemachte Pizza aus dem mobilen Pizzaofen, ausgewählte Vorspeisen und hausgemachte Desserts — persönlich und mediterran.",
    keywords:
      "Hochzeitscatering Lausitz, Hochzeitscatering Hoyerswerda, Pizza Catering Hochzeit, Catering Hochzeit, mobiler Pizzaofen Catering, Catering Events, Catering Lohsa",
    path: "/hochzeiten-events",
  });
  return (
    <div data-testid="weddings-page">
      <section className="relative h-[70vh] grain overflow-hidden">
        <img src={IMAGES.table} alt="" className="absolute inset-0 w-full h-full object-cover" />
        <div className="absolute inset-0 bg-gradient-to-b from-black/20 to-black/60" />
        <div className="relative z-10 max-w-[1400px] mx-auto px-6 lg:px-12 h-full flex items-end pb-16 text-white">
          <div>
            <p className="eyebrow text-white/80">{t.weddings.eyebrow}</p>
            <h1 className="font-display text-5xl md:text-7xl max-w-3xl mt-3 leading-[1.05]">{t.weddings.title}</h1>
          </div>
        </div>
      </section>

      <section className="max-w-[1400px] mx-auto px-6 lg:px-12 py-20 md:py-28 grid md:grid-cols-12 gap-12">
        <div className="md:col-span-6">
          <p className="text-base md:text-lg text-[hsl(var(--muted-foreground))] leading-relaxed">{t.weddings.body}</p>
          <Link to="/kontakt" data-testid="weddings-cta" className="mt-10 inline-flex items-center gap-2 px-6 py-3.5 text-xs tracking-[0.2em] uppercase font-semibold bg-[hsl(var(--primary))] text-[hsl(var(--primary-foreground))] hover:bg-[hsl(var(--accent))] rounded-sm">
            {t.weddings.cta} <ArrowRight size={14} />
          </Link>
        </div>
        <div className="md:col-span-6 md:pl-10">
          <h2 className="font-display text-3xl md:text-4xl mb-6">{t.weddings.includes_title}</h2>
          <ul className="space-y-3">
            {t.weddings.includes.map((item, i) => (
              <li key={i} data-testid={`weddings-include-${i}`} className="flex items-start gap-3 border-b border-border pb-3">
                <Check size={18} className="mt-1 text-[hsl(var(--primary))]" />
                <span>{item}</span>
              </li>
            ))}
          </ul>
        </div>
      </section>

      <section className="grid grid-cols-2 md:grid-cols-3 gap-8 md:gap-12 px-6 lg:px-12 max-w-[1300px] mx-auto pb-24">
        <div className="aspect-square overflow-hidden blob"><img src={IMAGES.pizza1} alt="" className="w-full h-full object-cover" /></div>
        <div className="aspect-square overflow-hidden blob-2"><img src={IMAGES.medFood} alt="" className="w-full h-full object-cover" /></div>
        <div className="aspect-square overflow-hidden blob-3"><img src={IMAGES.oven} alt="" className="w-full h-full object-cover" /></div>
      </section>
    </div>
  );
}
